import { Component } from '@angular/core';
import { 
  changeBackgroundColorPhoneNumberButtonMobile,
  changeBackgroundColorPhoneNumberButtonDesktop, 
  openClose, 
  openClosePhoneNumber 
} from 'src/assets/models/animations';

@Component({
  selector: 'app-phone-numbers',
  templateUrl: './phone-numbers.component.html',
  styleUrls: ['./phone-numbers.component.sass'],
  standalone: true,
  animations: [
    openClose,
    openClosePhoneNumber,
    changeBackgroundColorPhoneNumberButtonMobile,
    changeBackgroundColorPhoneNumberButtonDesktop
  ]
})
export class PhoneNumbersComponent {
  openedMobile: boolean = false;
  openedDesktop: boolean = false;

  ngOnInit(): void {
  }

  openOrCloseMenuMobile() {
    this.openedMobile = !this.openedMobile
  }

  openOrCloseMenuDesktop() {
    this.openedDesktop = !this.openedDesktop
  }
}
